<template>
    <div id="intros">
    <!-- Main wrapper  -->
      <div class="login-wrapper ">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-shadow">
                <div class="card-body">
                  <div class="form-section text-center">
                  <img
                    class="mb0 mt10"
                    src="static/assets/logo.jpg"
                    width="200"
                    style="border-radius: 20%;"
                  />
                  <h3 style="font-size: 26px; margin-top: 9px; color: #333;">SMART FREIGHT</h3>
                  <p class="mt-0 mb-0">Sign in with your account</p>
                </div>
                  <div class="alert alert-warning userLoginAttempts" role="alert">
                    you have
                    <b>{{loginAttempts}}</b> login attempts remaining
                  </div>
                  <form @submit.prevent="LoginUser()">
                    <div class="form-group"> <label>Email address</label>
                      <input type="email" class="form-control input-rounded f-s-14 emailAddress" placeholder="Email" @keyup="hideLogingAttempts()" ref="email"/>
                    </div>
                    <div class="form-group">
                      <label>Password</label>
                      <input type="password" class="form-control input-rounded f-s-14 userPassword" userPassword placeholder="Password" @keyup="hideLogingAttempts()" required/>
                    </div>
                    <div class="checkbox">
                      <label class="pull-right">
                        <a href="#">Forgotten Password?</a>
                      </label>
                    </div>
                    <button type="submit" class="btn btn-primary btn-block m-b-30 m-t-30 signButton btn-rounded" >Sign in</button>
                    <button type="button" class="btn btn-primary btn-block m-b-30 m-t-30 loagingLoader btn-rounded" > <span class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import authservice from "../configurations/authentications/auth";
import router from "../router/index"

export default {
  created() {
    let Auth = new authservice();

    const expireTime = Auth.loggedIn();
   
    if (expireTime !== null) {
      router.push("/dashboard");   
    } 
  },
  computed: mapGetters(["loginAttempts"]),
  methods:  mapActions(["LoginUser", "hideLogingAttempts"]),

};
</script>
<style scoped>
.loagingLoader {
  text-transform: lowercase;
  display: none;
}
.userLoginAttempts {
  display: none;
}
#intros {
  background: url("/static/assets/shipping.jpg") no-repeat;
  height: 100vh;
  background-size: cover;
  align-content: center;
}
</style>



// WEBPACK FOOTER //
// src/authentications/login.vue